import { Box, Container, Grid } from '@mui/material';
import { marketing } from '../../styles/theme';
import { NeutralColors } from '@neumind/shared/branding';
interface TwoColumnSectionProps {
  left: React.ReactNode;
  right: React.ReactNode;
  variant?: 'light' | 'dark' | 'gradient';
  reverseOnMobile?: boolean;
  alignItems?: 'flex-start' | 'center' | 'flex-end';
  spacing?: number;
}

export function TwoColumnSection({
  left,
  right,
  variant = 'light',
  reverseOnMobile = false,
  alignItems = 'center',
  spacing = 8,
}: TwoColumnSectionProps) {
  const bgStyles = {
    light: { bgcolor: 'background.default' },
    dark: { bgcolor: NeutralColors[900], backgroundImage: marketing.gradients.dark, color: 'white' },
    gradient: {
      background:
        'linear-gradient(135deg, rgba(77, 101, 255, 0.05) 0%, rgba(14, 165, 223, 0.05) 100%)',
    },
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        ...bgStyles[variant],
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={{ xs: 4, md: spacing }}
          alignItems={alignItems}
          direction={{ xs: reverseOnMobile ? 'column-reverse' : 'column', md: 'row' }}
        >
          <Grid item xs={12} md={6}>
            {left}
          </Grid>
          <Grid item xs={12} md={6}>
            {right}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}